import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { HeaderModule } from '../shared/component/common/header/header.module';
import { LabelModule } from '../shared/component/common/label/label.module';
import { ErrorComponent } from './error.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    HeaderModule,
    LabelModule,
  ],
  declarations: [ErrorComponent]
})
export class ErrorModule {}
